import {
    InferSubjects,
    AbilityBuilder,
    createMongoAbility,
    MongoAbility,
  } from '@casl/ability';
import type { GetUserDto } from '@server/routes/users/dto';
  

  type Subjects = InferSubjects<
    'all' | 'admin_page'
  >;
  type Actions = 'manage' | 'create' | 'read' | 'readAll' | 'update' | 'delete';
  export type AppAbility = MongoAbility<[Actions, Subjects]>;
  
  type User = {
    roles: string[];
  }
      
  export function createForUser(user?: GetUserDto) {
      const { can: allow, build } = new AbilityBuilder<AppAbility>(
        createMongoAbility,
      );

      if (!user) {
        return build();
      }
  
      if (user.roles?.includes('admin')) {
        allow('read', 'admin_page');
      }
  
      return build();
  }
  